
import { Component, Vue } from 'vue-property-decorator';
import store from "./store";

@Component({
  components: {},
})
export default class App extends Vue {
  default_layout = "no-sidebar"
  constructor(){
    super()
    this.initializeState()
  }
  created(){}
  get layout() {
    return (this.$route.meta.layout || this.default_layout) + "-layout";
  }

  get fixMenu() {
    return store.state.menu.fixMenu;
  }
  get menuOpen() {
    return store.state.menu.open;
  }
  
  async initializeState(){
  }
}
